import { useCallback, useEffect, useMemo, useState } from "react";
import { projectsAPI } from "../../../../../services/api";

export const useProjectTeamOptions = (projectId) => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamLoading, setTeamLoading] = useState(false);

  const memberLabel = useCallback((m) => {
    const fullName = `${m.first_name || ""} ${m.last_name || ""}`.trim();
    const name = fullName || m.email || `User ${m.user_id || ""}`;
    const role = (m.role || "").trim();
    return role ? `${name} (${role})` : name;
  }, []);

  const teamOptions = useMemo(() => {
    return (teamMembers || [])
      .filter((m) => m?.is_active !== false)
      .map((m) => ({
        key: m.id || m.user_id,
        value: m.user_id,
        label: memberLabel(m),
        role: m.role || "",
        email: m.email || "",
        first_name: m.first_name || "",
        last_name: m.last_name || "",
        is_active: m.is_active !== false,
        member_id: m.id,
      }));
  }, [teamMembers, memberLabel]);

  const load = useCallback(async () => {
    if (!projectId) return;
    setTeamLoading(true);
    try {
      const res = await projectsAPI.getTeam(projectId);
      setTeamMembers(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      console.warn("Failed to load project team:", e);
      setTeamMembers([]);
    } finally {
      setTeamLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    load();
  }, [load]);

  return { teamOptions, teamLoading, reloadTeam: load };
};
